import { Injectable } from '@angular/core';
import { DetailedEntityButtonService } from '../../shared/services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { CoreServiceRegistry } from '../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared/shared-service-registry';
import { ButtonItem } from '../../shared/button/button.model';
import { FleetMonitoringActionService } from './fleet-monitoring-action.service';
import { AUTO_ADD_ROW_EVENT, NEW_SEARCH_EVENT } from '../../shared/search/search-constants';
import { SearchEvent } from '../../shared/search/models/search-event';
import { ViewTransactionsPopupComponent } from 'src/app/shared/components/common/view-transactions-popup/view-transactions-popup.component';
import { FleetMonitoringDataEditorService } from './fleet-monitoring-data-editor.service';

@Injectable()
export class FleetMonitoringButtonService extends DetailedEntityButtonService {

  public actionService: FleetMonitoringActionService;
  
  constructor(public coreServiceRegistry: CoreServiceRegistry,
    public sharedServiceRegistry: SharedServiceRegistry , public dataEditor: FleetMonitoringDataEditorService) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public getAllButtons(): any {
    return {
      'search-main': [
        new ButtonItem('Create', this.resourceService.get('lbl_create_new_PG'), '', 'icon_new_doc.svg', [])
      ],
      'search-table': [
        new ButtonItem('Edit', this.resourceService.get('btn_edit'), '', 'icon_edit.svg', []),
        new ButtonItem('SaveTbl', this.resourceService.get('btn_save'), '', 'icon_save.svg', []),
        new ButtonItem('Delete', this.resourceService.get('btn_delete'), '', 'icon_delete.svg', []),
      ],
      'detail-main': [
        new ButtonItem('EditDtl', this.resourceService.get('btn_edit'), '', 'icon_edit.svg', []),
        new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'icon_save.svg', []),
        new ButtonItem('CancelDtl', this.resourceService.get('Cancel'), '', 'button-close.svg', []),
      ],
      'detail-table': [
        new ButtonItem('Add', this.resourceService.get('Add'), '', 'icon-add-new-row.svg', []),
        new ButtonItem('DeleteDtl', this.resourceService.get('btn_delete'), '', 'icon_delete.svg', []),
      ]
    };
  }

  public getButtonsForPanel(panelId: string) {
    return this.userButtonMap[panelId];
  }


  public initializeSearchPageButtons() {
      this.userButtonMap['search-table'] = this.loadButtonsByPrivilege(this.allButtonsMap['search-table']);
      if (this.dataService.displayMode === 'V') {
        this.rebuildButtonArray(this.userButtonMap['search-table'],
          [
            'Edit'
          ]);
      } else {
        this.rebuildButtonArray(this.userButtonMap['search-table'],
          [
            'SaveTbl', 'Delete'
          ]);
      }
      this.dataService.detailsSearchParams.actionButtons = this.getButtonsForPanel('search-table');
  }

  // this method sets the visible and enabled flags for the buttons based on the display mode
  public initializeDetailPageButtons(cellDataMap: any) {
    if (this.dataService.displayMode === 'C' || this.dataService.displayMode === 'E') {
      this.rebuildButtonArray(this.userButtonMap['detail-main'],
        [
           'Save',
           'CancelDtl'
        ]);
      this.rebuildButtonArray(this.userButtonMap['detail-table'],
        [
          'DeleteDtl',
          'Add'
        ]);
    } else {
      this.rebuildButtonArray(this.userButtonMap['detail-main'],
        [
         'EditDtl'
        ]);
      this.rebuildButtonArray(this.userButtonMap['detail-table'],
        [
          'DeleteDtl',
          'Add'
        ]);
      /* [LFWM-2159] - to fetch dynamic buttons when loading details page
      * dynamicButtonsExist boolean variable added to avoid multiple backend calls.
      * dynamicButtonsExist - false - on initial page load. initialized as false in details page component
      * dynamicButtonsExist - true - it will be true once we fetch the dynamic button list from backend */
    }
    this.userButtonMap['detail-main'] = this.loadButtonsByPrivilege(this.userButtonMap['detail-main']);
    this.userButtonMap['search-table'] = this.loadButtonsByPrivilege(this.userButtonMap['search-table']);
    this.userButtonMap['detail-table'] = this.loadButtonsByPrivilege(this.userButtonMap['detail-table']);
  }

  public setupEnabledButtonsInDetailPage(cellDataMap: any) {
    // [LFWM-2159] - detailMainButtons - temp array of detail main buttons in view or edit mode
    let detailMainButtons = [];
    if (this.dataService.displayMode === 'V') {
      if (this.dataService.primaryDataMap['status'].cVal !== 'CANC' && this.dataService.primaryDataMap['status'].cVal !== '9') {
        detailMainButtons = [
          'Save',
          'CancelDtl'

        ];
        this.rebuildButtonArray(this.userButtonMap['detail-table'],
          [
            'DeleteDtl',
            'Add'
          ]);
      } else {
        detailMainButtons = [
          'Save',
          'CancelDtl'
        ];
        this.rebuildButtonArray(this.userButtonMap['detail-table'],
          [
            'DeleteDtl',
            'Add'
          ]);
      }
    } else {
      detailMainButtons = [
        'Save',
        'CancelDtl'
            ];
      this.enableAllButtons(this.userButtonMap['detail-table']);
    }
    // [LFWM-2159] - adding dynamic buttons to detail main buttons
    if (this.dynamicButtons.length > 0) {
      this.dynamicButtons.forEach((button: any) => {
        detailMainButtons.push(button.staticButtonName.toUpperCase());
      });
    }
    /* [LFWM-2159] - re-initializing the detail main button array based on dynamic buttons fetched from backend and status of po */
  }

  public handleButtonActionForCreate(action: any) {
    let needOkConfirmation = false;
    if (action === 'Copy Value To All Rows') {
      needOkConfirmation = true;
    }
    if (needOkConfirmation) {
      const dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('err_msg_save_data'));
      this.confirmDialogService.okDialog(this.resourceService.get(dialogMsg));
    } else {
      this.performButtonActions(action);
    }
  }

  public handleButtonActionForEdit(action: any) {
    let needYesNoConfirmation = false;
    switch (action) {
      // if there are any actions which need confirmation, add it here.
      case 'Edit':
        needYesNoConfirmation = true;
        break;
      case 'Populate Transfer': {
        needYesNoConfirmation = true;
        break;
      }
    }
    if (needYesNoConfirmation) {
      const dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('msg_conf_save_data'));
      this.confirmDialogService.yesnocancelDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed: any) => {
        if (isConfirmed === true) {
          this.actionService.savePage().subscribe((response: any) => {
            if (response.statusCode && response.statusCode === 200) {
              const successMsg = 'msg_save_succ';
              this.alertService.clearAll().success(this.resourceService.get(successMsg));
              this.dataService.getDetailsSearchService().clearMarkerFlags();
              this.actionService.clearEditedFlags();
              this.navService.preventNavigation = false;
              this.performButtonActions(action);
            } else {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(response.statusMessage));
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
          });
        } else if (isConfirmed === false) {
          this.performButtonActions(action);
        }
      });
    } else {
      this.performButtonActions(action);
    }
  }

  public performButtonActions(action: any) {
    switch (action) {
      case 'Edit': {

        this.actionService.editPage();
        break;
      }

      case 'DeleteDtl': {
        if (this.dataService.displayMode === 'V') {
          this.alertService.warn('Please click edit button to delete the recipients');
        } else {
          this.actionService.dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('msg_conf_del'));
          this.actionService.successMsg = this.resourceService.get('msg_del_succ');
          this.actionService.errorMsg = this.resourceService.get('msg_sel_detail');
          this.actionService.delete();
        }
        break;
      }
      case 'Add': {
        if(this.dataService.displayMode !== 'V'){
          const searchCriteria = {
            conditions: [{
              mandatory: true,
              clauses: [{
                column: '',
                operation: '=',
                value: '',
                logicalOperation: '',
                typeOfField:''
              }],
              logicalOperation: 'AND'
            }]
          };
          this.alertService.clearAll();
          const modalRef: any = this.sharedServiceRegistry.sceModalService
            .showModal(ViewTransactionsPopupComponent,
              {
                overlayHeader: this.resourceService.get('Add User'),
                showHeader: true,
                overlayHeight: 480,
                overlayWidth: 1024
              });
          modalRef.content
            .initialize(this.dataService.primarySearchService, this.dataEditor, searchCriteria);
            modalRef.content.receiveEvent()
            .subscribe((event: any) => {
                if (event.type === 'cancel') {
                  let rowsData = this.dataService.primarySearchService.getPagedData().pageRows;
                  event.selectedItems.forEach(element => {
                    element.cells['isNewItem'] = { cVal: true };
                    element.cells['isSelected'] = false;
                   // element['isNewRow'] = true;
                   });  
                   event.selectedItems.forEach(element => {
                    rowsData.push(element);
                    });                   
                  this.dataService.primarySearchService.setPagedRows(rowsData);
                  const events = new SearchEvent(NEW_SEARCH_EVENT);
                  events.isSearchSuccess = true;
                  this.dataService.primarySearchService.publishEvent(events);
                  modalRef.hide();
                }
              });
            } else {
               this.alertService.warn('Please click edit button to add the recipients')
            }
            break;
        }

      case 'Cancel' :{
        break;
      }
      case 'SaveTbl': {
        this.actionService.successMsg = this.resourceService.get('msg_save_succ');
        const saveObs = this.actionService.savePageForTable();
        if (saveObs) {
          saveObs.subscribe((response) => {
            if (response.statusCode === 200) {
              this.alertService.clearAll().success(this.actionService.successMsg);
              if (this.dataService.displayMode === 'E') {
                this.dataService.setDisplayMode('V');
                this.initializeSearchPageButtons();
              }
              this.dataService.getSearchService().performSearch(); // Added to refresh the data
              this.navService.preventNavigation = false;
            } else {
              this.alertService.clearAll().error(this.resourceService.get(response.error));
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.get(error));
          });
        }
        break;
      }
      case 'Delete': {
        this.actionService.dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('msg_conf_del'));
        this.actionService.successMsg = this.resourceService.get('msg_del_succ');
        this.actionService.errorMsg = this.resourceService.get('msg_sel_detail');
        this.actionService.delete();
        break;
      }
      case 'Create': {
        this.actionService.showDetailsPage();
        break;
      }
       case 'EditDtl': {
         this.actionService.editPageDtl();
         break;
       }
       case 'Save': {
          this.actionService.successMsg = 'msg_save_succ';
          const saveObs = this.actionService.savePage();
          if (saveObs) {
            saveObs.subscribe((response) => {
              if (response.statusCode === 200) {
                // If there are line items in details page
                if (this.dataService.entityConfig.getShowDetailLineItems()) {
                  if (!this.dataService.getPrimarySelectedDocument()) {
                    this.dataService.setPrimarySelectedDocument(response.groupId);
                  }
                  // Setting Search Criteria in Details Search Service which is the input for Data Table in Details Accordion
                  if (this.dataService.displayMode === 'C') {
                    this.dataService.getDetailsSearchService().setSearchCriteria({
                      conditions: [{
                        mandatory: false,
                        clauses: [{
                          column: this.dataService.primarySearchParams.idProperty,
                          operation: '=',
                          value: this.dataService.getPrimarySelectedDocument(),
                          logicalOperation: null
                        }],
                        logicalOperation: null
                      }]
                    });
                 }
                  this.dataService.getDetailsSearchService().clearMarkerFlags();
                  if (this.dataService.detailsSearchService.getNewPageEventInProgress()) {
                    // this save has come while navigating to a new page. Hence continue the navigation
                    this.dataService.detailsSearchService.setNewPageEventInProgress(false);
                    // if this was a create flow, set it to edit flow
                    if (this.dataService.displayMode === 'C') {
                      this.dataService.setDisplayMode('E');
                      this.initializeButtons(this.dataService.primaryDataMap);
                    }
                    const evt = new SearchEvent(AUTO_ADD_ROW_EVENT);
                    this.dataService.detailsSearchService.publishEvent(evt);
                    return;
                  }
                }
                this.actionService.clearEditedFlags();
                const successMsg = 'msg_save_succ';
                this.alertService.clearAll().success(this.resourceService.get(successMsg));
                this.navService.preventNavigation = false;
                if (this.dataService.displayMode === 'C') {
                  this.navService.removeLastBreadCrumbItem();
                  let id;
                  if (this.dataService.getPrimarySelectedDocument()) {
                    id = this.dataService.getPrimarySelectedDocument();
                  } else {
                    id = response.groupId;
                  }
                  this.dataService.setDisplayMode('V');
                  this.initializeButtons(this.dataService.getPrimaryDataMap());
                  this.navService.retainAlerts().navigateWithRouteParams(this.dataService.getEntityConfiguration().getDetailPageRoute(), [id]);
                } else if (this.dataService.displayMode === 'E') {
                  this.dataService.setDisplayMode('V');
                  this.initializeButtons(this.dataService.getPrimaryDataMap());
                }
                this.dataService.detailsSearchService.performSearch();
              } else {
                 // If there are line items in details page
                if (this.dataService.entityConfig.getShowDetailLineItems()) {
                  if (this.dataService.detailsSearchService.getNewPageEventInProgress()) {
                    this.dataService.detailsSearchService.setNewPageEventInProgress(false);
                  }
              }
                this.alertService.clearAll();
                this.alertService.error(this.resourceService.get(response.statusMessage));
              }
            }, (error) => {
               // If there are line items in details page
              if (this.dataService.entityConfig.getShowDetailLineItems()) {
                if (this.dataService.detailsSearchService.getNewPageEventInProgress()) {
                  this.dataService.detailsSearchService.setNewPageEventInProgress(false);
                }
            }
              this.alertService.error(this.resourceService.get(error));
            });
          }
  
          break;
      }
       case 'CancelDtl': {
        this.actionService.dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('Are you sure want to navigate'));
        this.actionService.cancelDtl();
        break;
       }
    
    }
  }

  public exportAsExcelFromDetailHeader() {
    this.actionService.exportData(this.dataService.detailsSearchService, 'excel', this.dataService.primarySearchParams.tableId);
  }

  public exportAsCSVFromDetailHeader() {
    this.actionService.exportData(this.dataService.detailsSearchService, 'csv', this.dataService.primarySearchParams.tableId);
  }

  public exportAsExcelFromDetail() {
    this.actionService.exportData(this.dataService.detailsSearchService, 'excel');
  }

  public exportAsCSVFromDetail() {
    this.actionService.exportData(this.dataService.detailsSearchService, 'csv');
  }

  public loadButtonsByPrivilege(fullButtonList: Array<ButtonItem>) {
    if (fullButtonList) {
      fullButtonList.forEach((button: ButtonItem) => {
        this.enableButtonByPrivilege(button);
      });
      return fullButtonList.filter(button => button.isEnabled);
    } else {
      return [];
    }
  }
  
  public enableButtonByPrivilege(button: ButtonItem) {
    if (button.accessPrivilege === '') {
      button.isEnabled = true;
    }
    if (button.subItems) {
      button.subItems.forEach((subButton: any) => {
        this.enableButtonByPrivilege(subButton);
      });
    }
  }
}
